import * as icons from 'react-bootstrap-icons';
import MenuDrawer from './components/MenuDrawer';

export default function SideMenu({ user_name, clinic_name }) {
    return (
        <div className='home-side'>
            <div className='inner'>
                <div className='inner-inner'>
                    <div className='profile'>
                        <div className='image'>
                            <icons.Person size={70} />
                        </div>
                        <p className='mt-1'>{user_name}</p>
                        <small>{clinic_name}</small>
                    </div>
                    <MenuDrawer />
                </div>
            </div>
        </div>
    );
}